import { getAdminApiBaseUrl } from "@/utils/api/requestPasswordReset";

/**
 * Diagnostic telemetry for GUE-1339: reports the browser's clock at the
 * moment an MFA OTP code is submitted, so admin can measure client/server
 * drift and confirm (or rule out) a drifted authenticator-app device as the
 * cause of persistent "invalid code" enrollment failures.
 *
 * Fire-and-forget: never awaited by the caller, never throws, and never
 * delays the actual MFA submission — this is telemetry, not part of the
 * login flow.
 */

interface ReportMfaClockCheckParams {
  screen: string;
  userId?: string | null;
  orgId?: string | null;
  orgName?: string | null;
  authClientId?: string | null;
}

export function reportMfaClockCheck(params: ReportMfaClockCheckParams): void {
  const base = getAdminApiBaseUrl();
  if (!base) return;

  try {
    fetch(`${base}/api/public/mfa-clock-check`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...params, clientTimestamp: Date.now() }),
      mode: "cors",
      credentials: "omit",
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Telemetry must never block or break the MFA flow.
  }
}
